import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isValidPhoneNumber = (phoneNumber: string, country = 'FR'): boolean => {
    try {
        const parsedNumber = phoneUtil.parse(phoneNumber, country);
        return phoneUtil.isValidNumber(parsedNumber);
    } catch {
        return false;
    }
};

export const formatPhoneNumberDigits = (phoneNumber: string, country: string = 'FR'): string | null => {
    try {
        const parsedNumber = phoneUtil.parse(phoneNumber, country);
        if (phoneUtil.isValidNumber(parsedNumber)) {
            return String(parsedNumber.getNationalNumber()) || null;
        }
        return null;
    } catch {
        return null;
    }
};
